<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'app',
  components: {},
  props: [],
  data () {
    return {
      pageName: '',
      appInfo: this.$store.state.appInfo
    }
  },
  beforeCreate () {
  },
  async created () {
    if (this.Tool.isNull(this.appInfo)) {
      let appInfo = await this.$HTTP.ApiCommon.getAppInfo()
      this.$store.commit('setAppInfo', appInfo)
      this.appInfo = this.$store.state.appInfo
    }
    this.changeIcon()
  },
  async mounted () {
  },
  computed: {},
  watch: {
    $route: {
      handler: function (newVal) {
        this.pageName = newVal.name || ''
        this.changeTitle()
      },
      immediate: true
    },
    '$store.state.appInfo': {
      handler: function (newVal) {
        this.changeTitle()
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy () {
  },
  methods: {
    changeTitle () {
      this.Tool.debounce('changeTitle', () => {
        window.document.title = `${this.pageName ? (this.pageName + '-') : ''}${this.appInfo.organizationName || '后台管理系统'}`
      })
    },
    changeIcon () {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.appInfo.logoUrl
      console.log('changeIcon', link.href)
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
</script>
<style>
</style>
